<template>
    <v-server-table url="/api/admin/organisations/table" :columns="columns" :options="options" @loaded="addToolTips" class="trigger organisation-table" ref="table">
        <template slot="name" slot-scope="props">
            <router-link :to="{ name: 'admin.organisations.view', params: { id: props.row.id }}">{{ props.row.name }}</router-link>
        </template>
        <template slot="type" slot-scope="props">
            <b-badge pill variant="primary">{{ props.row.type.name }}</b-badge>
        </template>
        <template slot="city" slot-scope="props">
            <div v-if="props.row.addresses.length > 0">
                <span class="pointer" @click="tooltip(props.row.addresses[0])">{{ props.row.addresses[0].city}} <i class="fa fa-info-circle" aria-hidden="true"></i></span>
                <div class="thomastip" v-if="showToolTip(props.row.addresses[0])">
                    <address-helper :address="props.row.addresses[0]"></address-helper>
                </div>
            </div>
            <span v-else="">-</span>
        </template>
        <template slot="filter__type">
            <multi-select :options="types" :loading="!types" :deselectLabel="uLang('app.press_enter_to_remove')"
                          :selectLabel="uLang('app.press_enter_to_select')"  :selectedLabel="uLang('app.select')"
                          label="name" :placeholder="uLang('app.select_an_option')" @input="searchType"/>
        </template>
    </v-server-table>
</template>

<script>
    import Actions from './actions'
    import { TableMixin } from '~/mixins'
    import { event }  from '~/events'
    import MultiSelect from 'vue-multiselect'

    export default {
        name: 'index',
        mixins: [ TableMixin ],
        components: {
            'multi-select': MultiSelect,
        },
        props: {
            rowsPerPage: {
                type: String,
                default: "15"
            }
        },
        data () {
            return {
                columns: ['name', 'type', 'city', 'actions'],
                filterable: ['name', 'city'],
                templates: {
                    actions: Actions,
                },
                options: {
                    headings: {
                        name: this.uLang('app.name'),
                        type: this.uLang('app.type'),
                        city: this.uLang('app.city'),
                        actions: this.uLang('app.actions'),
                    },
                    customFilters: [
                        'type',
                    ],
                },
                openToolTips: [],
                types: [],
            }
        },

        created() {
            this.retrieveTypes();
        },

        methods: {
            async retrieveTypes() {
                const {data} = await window.axios.get(route('types.index'));
                this.types = data;
            },

            searchType(type) {
                let typeName = type !== null ? type.name : '';
                this.$refs.table.query.type = typeName;
                this.$refs.table.refresh();
            },

            addToolTips() {
                this.openToolTips = [];
                this.$refs.table.data = this.$refs.table.data.map((row) => {
                    row.addresses = row.addresses.map((address) => {
                        address.show = false;
                        return address
                    });
                    return row
                })
            },

            tooltip(address) {
                if (this.showToolTip(address)) {
                    return this.openToolTips.splice(this.openToolTips.indexOf(address.id), 1);
                }

                this.openToolTips.push(address.id)
            },

            showToolTip(address) {
                return this.openToolTips.includes(address.id);
            }
        },
        watch: {
            rowsPerPage(newValue) {
                this.$refs.table.setLimit(Number.parseInt(newValue, 10));
                this.$refs.table.refresh();
            }
        }
    }
</script>

<style lang="scss">
.organisation-table .VueTables__table {
    min-height: 300px;
}
</style>
